import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { searchSelectors } from '@app2/store/search/search.selectors';
import { searchActions } from '@app2/store/search/search.actions';

@Injectable()
export class SearchWidgetFacade {

  private store = inject(Store);

  public query$ = this.store.selectSignal(searchSelectors.selectQuery);

  public faps$ = this.store.selectSignal(searchSelectors.selectFaps);

  public isLoading = this.store.selectSignal(searchSelectors.selectFapsIsLoading);

  getFaps(q: string): void {
    this.store.dispatch(searchActions.loadFaps({ q, defaultList: true, ps: 4 }));
  }

}
